module.exports = __webpack_public_path__ + "img/VIRTUAL_ACCOUNT_BANK_BCA.138d824e.png";